import { PlusActions } from 'actions'
import { Button, HelpEmail, Notice, InstallButton } from 'components'
import { SUPPORT_EMAIL } from 'consts'
import InstalledDialog from './InstalledDialog'
import FailedDialog from './FailedDialog'

import './manageInstall.scss'

export default class ManageInstall extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object,
    router:      React.PropTypes.object.isRequired
  }

  static propTypes = {
    status:       React.PropTypes.object.isRequired,
    installed:    React.PropTypes.bool.isRequired,
    isInstalling: React.PropTypes.bool.isRequired,
    isUpgrade:    React.PropTypes.bool.isRequired,
    failed:       React.PropTypes.bool.isRequired,
    installNow:   React.PropTypes.bool
  }

  constructor(props) {
    super(props)

    this.state = {
      showFailedDialog: false,
      showInstalledDialog: false
    }
  }

  upgrade() {
    PlusActions.install(this.context.currentUser, true)
  }

  handleRequestInstall() {
    PlusActions.requestPlusInstall(this.context.currentUser)
  }

  handleSelfInstall() {
    PlusActions.selfInstall()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.failed) {
      this.setState({ showFailedDialog: true })
      return
    }

    if (!this.props.installed && nextProps.installed && !nextProps.isUpgrade) {
      this.setState({ showInstalledDialog: true })
    }
  }

  maybeShowFailedDialog() {
    return this.state.showFailedDialog && <FailedDialog />
  }

  maybeShowInstalledDialog() {
    return this.state.showInstalledDialog &&
      <InstalledDialog installed={this.props.installed}
        upgrade={this.props.isUpgrade}
        hasInclude={this.props.status.hasInclude}
        handleRequestInstall={::this.handleRequestInstall}
        handleSelfInstall={::this.handleSelfInstall} />
  }

  downgrade() {
    // BUG: the success or failure of .downgrade isn't handled and the router is called regardless, should handle errors and display confirmation on success
    // BUG: no confirmation dialog shown https://trello.com/c/pKCuvmbM/602-uninstall-downgrade
    PlusActions.downgrade(this.context.currentUser)
    this.context.router.replace('/')
  }

  renderInstall() {
    // Fetching plus installation status
    if (this.props.status.installed === undefined) return null
    if (this.props.isInstalling)
      return (
        <div className="flex-center--horizontal">
          <Button
            label='Installing...'
            buttonType="primary"
            disabled={true}
            className='manageplus__row__btn'
          />
          <h4 className="small-spacing2--top">Please wait: Currently installing Plug in SEO Plus in your shop...</h4>
        </div>
      )

    if (this.props.status.installed === true && this.props.status.hasInclude === false)
      return (
        <div className="installed-notice">
          <Notice alert header="Plug in SEO is partially installed">
            <p>Plug in SEO requires one more piece of code to be added manaully to your theme.</p>
            <p className="small-spacing--top">Already requested an install? One of our team members will be in touch within 1 business day to help you get set up.</p>
            <p className="small-spacing--top">Want to install yourself? Follow these instructions: <a href="https://support.pluginuseful.com/hc/en-us/articles/23534794660244-How-do-I-install-Plug-in-SEO-Plus-in-my-theme" target="_blank">How to Install Plug in SEO Plus In Your Theme</a>.</p>
            <p className="small-spacing--top">If you need any help email us at <HelpEmail />.</p>
          </Notice>
        </div>
      )

    if (this.props.status.installed === false) {
      return (
        <div className="flex-center--horizontal">
          <InstallButton
            label='Install'
            buttonType="cta"
            status={this.props.status}
            className='manageplus__row__btn'
            installNow={this.props.installNow}
            currentUser={this.context.currentUser}
          />
          <h4 className="small-spacing2--top">Install Plug in SEO Plus in your shop</h4>
        </div>
      )
    } else if (this.props.status.needsUpgrade) {
      return (
        <div className="flex-center--horizontal">
          <Button
            label='Upgrade'
            buttonType="primary"
            onTouchTap={::this.upgrade}
            className='manageplus__row__btn'
          />
          <h4 className="small-spacing2--top">There&apos;s a new version of Plug in SEO Plus available</h4>
        </div>
      )
    }
    
    // Installed and no further action needed
    return null
  }

  render() {
    return (
      <div>
        <div className='manageinstall'>
          <div className='manageinstall__row'>
            {this.renderInstall()}
          </div>
        </div>
        { this.maybeShowInstalledDialog() }
        { this.maybeShowFailedDialog() }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/plus/ManageInstall.js